// extracted by mini-css-extract-plugin
export default {"flex":"HVBreadcrumbs_module-TOCMW4DR_flex__k3TsF","text":"HVBreadcrumbs_module-TOCMW4DR_text__xj+fH","textActive":"HVBreadcrumbs_module-TOCMW4DR_textActive__QT3CI"};